import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Col, Container, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import { Errors } from '../form';
import PaymentMethodSelector from '../PaymentMethodSelector';
import { filterSubPaymentMethodsByProduct } from '../../utils/payments';

export const renderServerErrors = (error) => (
  <Errors
    code={error}
    className="mt-3"
    defaultTitle={<FormattedMessage id="ERRORS.defaultTitle" />}
    defaultValue={<FormattedMessage id="ERRORS.defaultMessage" />}
    errors={{
      CARD_DELETION_500: {
        title: <FormattedMessage id="ERRORS.CARD_DELETION_500.title" />,
        value: <FormattedMessage id="ERRORS.CARD_DELETION_500.value" />
      }
    }}
  />
);

const MethodSelectionPage = ({
  location,
  methods,
  ...props
}) => {
  const { search } = location;
  const { error } = queryString.parse(search);
  const [subPaymentMethods, setSubPaymentMethods] = useState([]);

  useEffect(() => {
    if (!props.subPaymentMethods) {
      props.getSubPaymentMethods({ paymentMethod: props.currentPaymentMethod });
    }
  }, [props.getSubPaymentMethods]);

  useEffect(() => {
    if (props.subPaymentMethods?.length > 0) {
      setSubPaymentMethods(props.subPaymentMethods);
      if (props.isSingleSubscriptionClient) {
        const filteredMethods = filterSubPaymentMethodsByProduct(
          props.planSelected,
          props.subPaymentMethods,
          props.userData?.country,
          props.currentPaymentMethod
        );
        setSubPaymentMethods(filteredMethods);
      }
    }
  }, [
    props.subPaymentMethods?.length,
    props.isSingleSubscriptionClient,
    props.planSelected,
    props.userData?.country
  ]);

  return (
    <Container className="MethodSelectionPage">
      {error && (
        <Row>
          <Col md={12}>{renderServerErrors(error)}</Col>
        </Row>
      )}

      <Row className="">
        <PaymentMethodSelector {...props} methods={methods} subPaymentMethods={subPaymentMethods} />
      </Row>
    </Container>
  );
};

MethodSelectionPage.defaultProps = {
  subscriberMembership: null,
};

MethodSelectionPage.propTypes = {
  subPaymentMethods: PropTypes.array,
  planSelected: PropTypes.object,
  isSingleSubscriptionClient: PropTypes.bool,
  setCurrentSubPaymentMethod: PropTypes.func,
  currentPaymentMethod: PropTypes.string,
  userData: PropTypes.object,
  methods: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  getSubPaymentMethods: PropTypes.func.isRequired,
};

export default MethodSelectionPage;
